import React from "react";
import { List, Box } from "@mui/material";
import Loader from "../../../../components/Loader";
import ListItems from "./ListItem";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useBoardAttachmentsList } from "./hooks/useBoardAttachmentsList";

function AttachmentsList({ isMobile }) {
  const { id } = useBoardIdByKey();
  const { attachmentItems, hasAttachments, isLoading, isError, refetch } =
    useBoardAttachmentsList(id);

  return (
    <div>
      <p
        className={`blue-text-color ${
          isMobile ? "attachment-text" : "attachment-list-header-text"
        }`}
      >
        Attachments list:
      </p>
      <Box sx={{ height: "16px" }}></Box>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && !isError && hasAttachments && (
        <List
          dense
          sx={{
            width: "100%",
          }}
        >
          {attachmentItems.map((attachment, index) => (
            <ListItems
              attachment={attachment}
              refetch={refetch}
              isMobile={isMobile}
              key={`board-attachment-list-item-${index}`}
            />
          ))}
        </List>
      )}
      {!isLoading && !hasAttachments && (
        <p className="empty-attachment-list">No Attachments</p>
      )}
      {!isLoading && isError && <div>No Attachments</div>}
    </div>
  );
}

export default AttachmentsList;
